import { ExamAnswerSelectProps } from "./ExamAnswerSelect";

export const examAnswerSelectPlaceholderProps: ExamAnswerSelectProps = {
  answerLabels: ["Lat", "Vimana", "Gopura", "Shikhara"],
  selectedAnswerIndex: 0,
  correctAnswerIndex: null,
  // tslint:disable-next-line:no-empty
  onChangeAnswerIndex: () => {},
};
